import { systemIds } from '@/shared/utils';
const commonFunc = (path) => {
    return {
        path: path,
        systemId: systemIds['task'], // 为了获取基础路由
    };
};
export const taskToPathNameMap = {
    task1100: ({ businessKey }) => commonFunc(`/supervision/assign/detail?id=${businessKey}`),
    task1300: () => commonFunc(`/taskWarning`),
};
